import { Component } from '@angular/core';

@Component({
  selector: 'wp-menu',
  standalone: true,
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent {}
